export const PAGE_SCG_LIVE = [
  {
    text: 'Test SCG West Live',
    value: '108496771338010'
  },
  {
    text: 'Home Choice Live',
    value: '100378482209868'
  },
  {
    text: 'Chang Family Live Fair',
    value: '109181747969457'
  },
  {
    text: 'Esan Chang Family Live',
    value: '103800371873416'
  },
  {
    text: 'สุทธิพงศ์ ค้าส่ง Live',
    value: '108308318379330'
  },
  {
    text: 'สินค้าซิเมนต์ไทย ค้าส่ง Live',
    value: '101127682506041'
  },
  {
    text: 'Northern Chang Family Live',
    value: '100274418904517'
  },
  {
    text: 'Sukhothaicemen Live',
    value: '108556638438120'
  },
  {
    text: 'Northern2 Chang Family Live',
    value: '108026141827592'
  },
  {
    text: 'เอสซีจี โฮมบุญถาวร ชุมแพ-เปรมปรีดิ์',
    value: '490162721055346'
  },
  {
    text: 'NPD - Test Live',
    value: '115739694445355'
  },
  {
    text: 'Southern Chang Family Live',
    value: '100396882225293'
  },
  {
    text: 'YALA YONG HUAD ยะลาย่งฮวด',
    value: '178737485661189'
  },
  {
    text: 'UNIX ยูนิกซ์',
    value: '608979672643642'
  },
  {
    text: 'ท็อปโปร',
    value: '769473233454900'
  }
]



// WEBPACK FOOTER //
// ./src/constants/scg_live.js